import React from 'react';
import { Table, Empty, Tooltip ,Tag,Button} from 'antd';

export default function Resumen(props) {

    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Comprobante',
                        dataIndex: 'comprobante',
                        key: 'comprobante',
                        align: 'center'
                    },
                    {
                        title: 'Tipo',
                        dataIndex: 'tipo',
                        key: 'tipo'
                    },
        
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'metodoPago',
                        key: 'metodoPago',
                        align: 'center',
                
                    },
                    {
                        title: 'Moneda',
                        dataIndex: 'moneda',
                        key: 'moneda',
                        align: 'center',

                    },
                 
                    {
                        title: 'Monto',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )

                    },
          

                ]}
            />
        </div>
    );
}